import React, { useMemo } from "react";
import { useSetAtom } from "jotai";
import { useItemGroups } from "atoms/itemsGropAtom";
import {
  setInfoModalAtom,
  setPropertiesProductAtom,
} from "atoms/modalAtom/modalAtom";

import { Button, EButtonVariant } from "components/Button/Button";

export function AddProductButton() {
  const { itemGroupsState } = useItemGroups();
  const setPropertiesProduct = useSetAtom(setPropertiesProductAtom);
  const setInfoModal = useSetAtom(setInfoModalAtom);

  const canCreate = useMemo(
    () => !!itemGroupsState.activeItemsGroup,
    [itemGroupsState.activeItemsGroup]
  );

  const handleClick = () => {
    if (canCreate) {
      setPropertiesProduct(false);
    } else {
      setInfoModal({
        title: "Выберите группу, в которой хотите создать товар",
      });
    }
  };

  return (
    <Button
      variant={canCreate ? EButtonVariant.SECONDARY : EButtonVariant.PRIMARY}
      icon="plus"
      onClick={handleClick}
    />
  );
}
